<aside
  [ngClass]="{
    'w-[280px] fixed bg-[#1E2124] h-[100svh] z-[100]': visible,
    'xl:w-[240px]': visible && mode !== 'overlay'
  }"
>
  @if (visible) {
  <app-menu class="h-full"></app-menu>
  }
</aside>
